<div class="modal-content" joyrideStep="firstStep" stepPosition="bottom" title="Novo Projeto"
  text="Nessa etapa, você digita o título do projeto ou utiliza o botão MENTORAR TÍTULO, localizado ao lado do campo do título.">
  <div class="modal-header">
    <h5 class="modal-title" id="projectTitle">
      <div *ngIf="!project.id"><i class='bx bx-folder-open'></i> Novo Projeto</div>
      <div *ngIf="project.id"><i class='bx bx-folder-open'></i> Editar Projeto</div>
      <p>Informe os dados do seu projeto.</p>
    </h5>
    <div>
      <a (click)="activeModal.dismiss()">
        <i class='bx bx-x'></i>
      </a>
    </div>
  </div>
  <div [formGroup]="projectForm">
    <div class="modal-body" id="headingNewProject">
      <div class="row">
        <div class="col-md-8 form-group">
          <label for="title">Título *</label>
          <div class="input-group">
            <input type="text" formControlName="title" class="form-control" id="title" minlength="10"
              [ngClass]="{ 'is-invalid': submitted }" />
            <div class="input-group-append">
              <button type="button" class="button-input" id="api-call-btn" (click)="callOpenAiModal()">
                Mentorar títulos
              </button>
            </div>
          </div>
          <div class="invalid-feedback">
            <small *ngIf="projectForm.get('title').hasError('required')">
              Título não foi informado
            </small>
            <small *ngIf="projectForm.get('title').hasError('minlength')">
              Título deve ter no mínimo 10 caracters.
            </small>
          </div>
        </div>

        <div class="col-md-4 form-group">
          <label for="forecast">Previsão de entrega *</label>
          <div class="input-group">
            <input type="text" formControlName="forecast" (click)="d.toggle()" ngbDatepicker #d="ngbDatepicker"
              class="form-control inputmask" id="forecast" [ngClass]="{
                'is-invalid':
                  submitted && projectForm.get('forecast').hasError('required')
              }" />
            <div class="input-group-append">
              <button type="button" class="button-input" (click)="d.toggle()">
                <i class='bx bx-calendar'></i>
              </button>
            </div>
            <small class="invalid-feedback" *ngIf="
                submitted && projectForm.get('forecast').hasError('required')
              ">
              Informe a previsão, é necessário.
            </small>
          </div>
        </div>
      </div>

      <div class="row" *ngIf="hasTemplates()">
        <div class="col form-group">
          <select class="form-control" [(ngModel)]="templateSelection" [ngModelOptions]="{ standalone: true }"
            (change)="handleTemplateSelection()">
            <option [value]="''">Selecione um template existente</option>
            <option *ngFor="let template of templates" [value]="template.id">
              {{ template.name_template }}
            </option>
          </select>
        </div>
      </div>

      <div class="row" *ngIf="!project.id && !this.templateSelection">
        <div class="col w-100">
          <app-template-form #templateForm [projectId]="projectId" [formTemplateVisible]="selectTipoVisible"
            [nameAffiliation]="nameAffiliation"></app-template-form>
        </div>
      </div>

      <div class="col text-center d-flex justify-content-center align-items-center">
        <button [attr.data-target]="'#newProjectModalCollapse'" class="button button-cancel collapsed"
          data-toggle="collapse" aria-expanded="false" aria-controls="collapseThree" #btnCollapse
          (click)="expandClick(btnCollapse)">
          Mais Informações
          <i class='bx bx-chevron-down-circle' *ngIf="!hasCollapsed"></i>
          <i class='bx bx-chevron-up-circle' *ngIf="hasCollapsed"></i>
          <!-- <i class="fas fa-sort-down" *ngIf="!hasCollapsed"></i>
          <i class="fas fa-sort-up" *ngIf="hasCollapsed"></i> -->
        </button>
      </div>

      <div id="newProjectModalCollapse" class="collapse" aria-labelledby="headingNewProject" data-parent="#accordion">
        <div class="form-group">
          <label for="description">Descrição</label>
          <textarea formControlName="description" class="form-control" rows="2" id="description"
            placeholder="escreva aqui..."></textarea>
          <small class="form-text text-muted">Campo de informações complementares opcional.</small>
        </div>
        <div class="form-group">
          <label for="referenceType">Normas</label>
          <select class="custom-select" id="referenceType" formControlName="referenceType" [ngClass]="{
              'is-invalid':
                submitted &&
                projectForm.get('referenceType').hasError('required')
            }">
            <option *ngFor="let reference of references_type" [value]="reference.id">
              {{ reference.name }}
            </option>
          </select>
          <small class="invalid-feedback" *ngIf="
              submitted && projectForm.get('referenceType').hasError('required')
            ">
            tipo de referencia não foi informada
          </small>
        </div>
        <div class="form-group">
          <label for="magazine">Revistas/Periódicos
            <em class="text-muted">(* confirme estas informações com a sua instituição)</em></label>
          <ng-select [items]="periodic$ | async" bindLabel="name" [addTag]="false" [multiple]="true"
            [hideSelected]="true" [trackByFn]="trackByFn" [minTermLength]="2" [loading]="periodicLoading"
            typeToSearchText="Digite 2 ou mais caracteres" [typeahead]="periodicInput$" [(ngModel)]="selectedPeriodics"
            [ngModelOptions]="{ standalone: true }">
          </ng-select>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="button button-cancel" (click)="activeModal.dismiss()">
        Voltar
      </button>
      <button type="button" (click)="save()" [attr.data-loader]="!submitted" btnloader class="button button-primary">
        Salvar
      </button>
    </div>
  </div>
</div>